import { api } from '../../api/client';
import type { CriticalIssue, HealthTrendDay, ReadinessResponse } from './types';

export async function fetchHealthIssues(): Promise<CriticalIssue[]> {
  const res = await api.get<{ issues: CriticalIssue[] }>('/api/health/issues');
  return res.issues;
}

export async function fetchHealthTrends(days = 30): Promise<HealthTrendDay[]> {
  const res = await api.get<{ days: HealthTrendDay[] }>(`/api/health/trends?days=${days}`);
  return res.days;
}

export async function fetchReadiness(): Promise<ReadinessResponse> {
  return api.get<ReadinessResponse>('/api/health/readiness');
}
